import { CampaignChecklistActionsController } from './campaign-checklist-actions.controller'

function campaignChecklistActions () {
  return {
    scope: {
      campaign: '=',
      action: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-checklist-actions/campaign-checklist-actions.html?$$REVISION$$',
    controller: CampaignChecklistActionsController
  }
}

export { campaignChecklistActions }
